import { render } from "./NotRight.vue?vue&type=template&id=785fb7b5"
import script from "./NotRight.vue?vue&type=script&lang=js"
export * from "./NotRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__